import { render, staticRenderFns } from "./ResidentAdd.vue?vue&type=template&id=1ae6154b&scoped=true"
import script from "./ResidentAdd.vue?vue&type=script&lang=js"
export * from "./ResidentAdd.vue?vue&type=script&lang=js"
import style0 from "./ResidentAdd.vue?vue&type=style&index=0&id=1ae6154b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ae6154b",
  null
  
)

export default component.exports